/**
 * Created by Victor Rojo on 4/9/19.
 */
import { Component, Input, Output, EventEmitter }     from '@angular/core';
import { Router }                     from '@angular/router';

@Component({
  selector: 'iplace-bc',
  templateUrl: './IPlaceBreadCrumb.component.html',
  styleUrls: ['./IPlaceBreadCrumb.component.css']
})
export class IPlaceBreadCrumbComponent {

  private _iplaces:any[];
  private _sectionTree:any;
  private _selectediPlace:string;
  private _selectedSection:string;
  showDashboardLink = false;

  @Output() public sectionSelected: EventEmitter<any> = new EventEmitter();

  iplaceMap = {};
  sectionMap = {};
  multiSection = false;

  constructor(private router: Router) {
  }

  get iplaces(): any[] {
    return this._iplaces;
  }

  @Input()
  set iplaces(iplaces: any[]) {
    this._iplaces = iplaces;
    this.showDashboardLink = iplaces && iplaces.length > 1;
    this.iplaceMap = {};
    if ( iplaces ) {
      this.iplaceMap = iplaces.reduce(function(map, iplace) {
        map[iplace.idiPlace] = iplace;
        return map;
      }, {});
    }
  }

  get sectionTree(): any {
    return this._sectionTree;
  }

  @Input()
  set sectionTree(sectionTree: any) {
    this._sectionTree = sectionTree;
    this.sectionMap = {};
    this.updateSectionMap(sectionTree);
    this.multiSection = sectionTree && sectionTree.children && sectionTree.children.length;
  }

  get selectediPlace(): string {
    return this._selectediPlace;
  }

  @Input()
  set selectediPlace(selectediPlace: string) {
    this._selectediPlace = selectediPlace;
  }

  get selectedSection(): string {
    return this._selectedSection;
  }

  @Input()
  set selectedSection(selectedSection: string) {
    this._selectedSection = selectedSection;
  }

  updateSectionMap(section: any){
    if ( section ) {
      this.sectionMap[section.sectionId] = section;
      section.children.forEach(s => this.updateSectionMap(s));
    }
  }

  navigateToSearch(){
    if ( this._selectediPlace ) {
      this.sectionSelected.emit(null);
    }
  }

  selectSection(e:any){
    this.sectionSelected.emit(e);
  }
}
